export enum TrainingStatus {
  IN_APPROVAL = 'in_approval',
  WAITING_LIST = 'in_waiting_list',
}

export enum TrainingAvailability {
  DRAFT = 'draft',
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}

export enum TrainingSortPosition {
  FIRST = 0,
  SECOND = 1,
  THIRD = 2,
}
